/* Emirates Premium — moteur commun « Trouve mon parfum » + « Essaie aussi »
   Données olfactives : assets/ep-finder-data.json (genres et pyramides vérifiés)
   Données boutique en direct : /collections/all?view=ep-finder (prix, stock, photo, variante) */
(function () {
  if (window.EPFinder) return;

  var LANG = /^en/i.test(document.documentElement.lang || '') ? 'en' : 'fr';
  var EN = LANG === 'en';
  var FAMS = EN ? [
    { k: 'frais', l: 'Fresh', ex: 'citrus, aromatic' },
    { k: 'aquatique', l: 'Marine', ex: 'aquatic, salty' },
    { k: 'floral', l: 'Floral', ex: 'rose, jasmine, white flowers' },
    { k: 'fruite', l: 'Fruity', ex: 'red berries, pear, peach' },
    { k: 'gourmand', l: 'Gourmand', ex: 'vanilla, caramel, coffee' },
    { k: 'boise', l: 'Woody', ex: 'sandalwood, cedar, vetiver' },
    { k: 'ambre', l: 'Amber', ex: 'amber, incense, resins' },
    { k: 'epice', l: 'Spicy', ex: 'saffron, cinnamon, pepper' },
    { k: 'oud', l: 'Oud & leather', ex: 'oud, leather, tobacco' }
  ] : [
    { k: 'frais', l: 'Frais', ex: 'agrumes, aromatique' },
    { k: 'aquatique', l: 'Marin', ex: 'aquatique, iodé' },
    { k: 'floral', l: 'Floral', ex: 'rose, jasmin, fleurs blanches' },
    { k: 'fruite', l: 'Fruité', ex: 'fruits rouges, poire, pêche' },
    { k: 'gourmand', l: 'Gourmand', ex: 'vanille, caramel, café' },
    { k: 'boise', l: 'Boisé', ex: 'santal, cèdre, vétiver' },
    { k: 'ambre', l: 'Ambré', ex: 'ambre, encens, résines' },
    { k: 'epice', l: 'Épicé', ex: 'safran, cannelle, poivre' },
    { k: 'oud', l: 'Oud et cuir', ex: 'oud, cuir, tabac' }
  ];
  var FAML = {}; FAMS.forEach(function (f) { FAML[f.k] = f.l; });
  var DISLIKES = [[EN ? 'Oud' : 'Oud', ['oud']], [EN ? 'Leather & tobacco' : 'Cuir et tabac', ['cuir', 'daim', 'tabac']], [EN ? 'Too sweet' : 'Trop sucré', null]];
  var TX = EN ? {
    creation: 'Original', creationLine: 'An original creation by the house', adn: 'Same DNA', adnLine: 'Same DNA as ', res: 'Similar', resLine: 'Reminiscent of ', eq: 'Equivalent', eqLine: 'In the spirit of ',
    notes: 'See the notes', top: 'Top', heart: 'Heart', base: 'Base', allNotes: 'Notes', match: '% match', add: 'Add', addAria: 'Add {n} to cart', adding: 'Adding…', added: 'Added ✓', unavailable: 'Unavailable',
    g: { Femme: 'Women', Homme: 'Men', Mixte: 'Unisex' }
  } : {
    creation: 'Création', creationLine: 'Création originale de la maison', adn: 'Même ADN', adnLine: 'Même ADN que ', res: 'Ressemblance', resLine: 'Rappelle ', eq: 'Équivalent', eqLine: 'Dans la lignée de ',
    notes: 'Voir les notes', top: 'Tête', heart: 'Cœur', base: 'Fond', allNotes: 'Notes', match: ' % compatible', add: 'Ajouter', addAria: 'Ajouter {n} au panier', adding: 'Ajout…', added: 'Ajouté ✓', unavailable: 'Indisponible',
    g: { Femme: 'Femme', Homme: 'Homme', Mixte: 'Mixte' }
  };
  var NOTE_EN = null;
  function tn(n) { return NOTE_EN && NOTE_EN[n] ? NOTE_EN[n] : n; }
  var MOOD = {
    frais: { pos: { frais: 1, aquatique: 1, fruite: .5 }, neg: { oud: 1, ambre: .8, gourmand: .6, epice: .4 } },
    doux: { pos: { gourmand: .7, floral: .7, fruite: .3 }, neg: { oud: 1, epice: .6, aquatique: .3 } },
    chaud: { pos: { gourmand: .8, ambre: 1, boise: .5, epice: .6 }, neg: { frais: .8, aquatique: 1 } },
    intense: { pos: { oud: 1, ambre: .9, epice: .8, boise: .5 }, neg: { frais: .8, aquatique: 1, fruite: .3 } }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { s = String(s || '').toLowerCase(); try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {} return s.replace(/[^a-z0-9]+/g, ' ').trim(); }
  function notesOf(p) { return p.p ? [].concat(p.p[0] || [], p.p[1] || [], p.p[2] || []) : (p.nl || []); }
  function hasGroup(p, keys) { var hit = []; notesOf(p).forEach(function (n) { keys.forEach(function (k) { if (n.indexOf(k) >= 0 && hit.indexOf(n) < 0) hit.push(n); }); }); return hit; }
  var CANON = [['rose', 'rose'], ['jasmin', 'jasmin'], ['musc', 'musc'], ['vanille', 'vanille'], ['oud', 'oud'], ['cèdre', 'cèdre'], ['bois de santal', 'santal'], ['santal', 'santal'], ['patchouli', 'patchouli'], ['ambre gris', 'ambre gris'], ['ambre', 'ambre'], ['caramel', 'caramel'], ['praliné', 'praliné'], ['fève tonka', 'tonka'], ['mandarine', 'mandarine'], ['citron', 'citron'], ['cassis', 'cassis'], ['framboise', 'framboise'], ['poire', 'poire'], ['pomme', 'pomme'], ['cuir', 'cuir'], ['tabac', 'tabac'], ['safran', 'safran'], ['encens', 'encens'], ['oliban', 'encens'], ['iris', 'iris'], ['lavande', 'lavande'], ['café', 'café'], ['cerise', 'cerise'], ['pistache', 'pistache'], ['noix de coco', 'coco'], ['lait', 'lait']];
  function canon(n) { for (var i = 0; i < CANON.length; i++) if (n.indexOf(CANON[i][0]) === 0) return CANON[i][1]; return n; }
  function noteVec(p) {
    if (p._nv) return p._nv; var v = {};
    if (p.p) [[0, 1], [1, 1.2], [2, 1.4]].forEach(function (x) { (p.p[x[0]] || []).forEach(function (n) { var k = canon(n); v[k] = (v[k] || 0) + x[1]; }); });
    else (p.nl || []).forEach(function (n) { var k = canon(n); v[k] = (v[k] || 0) + 1.1; });
    p._nv = v; return v;
  }
  function cos(a, b) { if (!a || !b) return 0; var s = 0, na = 0, nb = 0, k; for (k in a) { na += a[k] * a[k]; if (b[k]) s += a[k] * b[k]; } for (k in b) nb += b[k] * b[k]; return na && nb ? s / Math.sqrt(na * nb) : 0; }
  function similarity(a, b) { return 0.35 * cos(a.f, b.f) + 0.65 * cos(noteVec(a), noteVec(b)); }

  /* ——— chargement ——— */
  var cache = null;
  function load(cfg) {
    if (cache) return cache;
    function live() {
      try { var s = sessionStorage.getItem('epf-live-' + LANG); if (s) { var o = JSON.parse(s); if (Date.now() - o.t < 10 * 60 * 1000) return Promise.resolve(o.d); } } catch (e) {}
      var all = {};
      function page(n) {
        return fetch(cfg.liveUrl + (cfg.liveUrl.indexOf('?') >= 0 ? '&' : '?') + 'page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (t) {
            var j = JSON.parse(t); j.items.forEach(function (it) { all[it.h] = it; });
            if (j.page < j.pages && n < 12) return page(n + 1);
          });
      }
      return page(1).then(function () { try { sessionStorage.setItem('epf-live-' + LANG, JSON.stringify({ t: Date.now(), d: all })); } catch (e) {} return all; });
    }
    var notesP = EN && cfg.notesUrl ? fetch(cfg.notesUrl).then(function (r) { return r.json(); }).then(function (m) { NOTE_EN = m; }).catch(function () {}) : Promise.resolve();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function locUrl(u) { return u && root !== '/' && u.indexOf(root) !== 0 && u.charAt(0) === '/' ? root + u.slice(1) : u; }
    cache = Promise.all([fetch(cfg.dataUrl).then(function (r) { return r.json(); }), live(), notesP]).then(function (res) {
      var data = res[0], lv = res[1], P = [];
      Object.keys(data).forEach(function (h) {
        var p = data[h], l = lv[h]; if (!l) return;
        p.h = h; p.id = l.id; p.price = l.pr; p.cp = l.cp; p.av = l.a; p.url = locUrl(l.u); p.img = l.img;
        P.push(p);
      });
      return { P: P, byH: P.reduce(function (m, p) { m[p.h] = p; return m; }, {}) };
    });
    return cache;
  }

  /* ——— score du quiz ——— */
  function scoreAll(P, st) {
    var out = [];
    P.forEach(function (p) {
      if (p.x || !p.av) return;
      if (st.gender && st.gender !== 'all') { if (st.gender === 'Mixte' ? p.g !== 'Mixte' : (p.g !== st.gender && p.g !== 'Mixte')) return; }
      if (st.budget && st.budget !== 'all' && p.price != null) {
        if (st.budget === 'lt35' && !(p.price < 35)) return;
        if (st.budget === '35-45' && !(p.price >= 35 && p.price <= 45)) return;
        if (st.budget === 'gt45' && !(p.price > 45)) return;
      }
      var bad = false;
      (st.avoid || []).forEach(function (i) { var d = DISLIKES[i]; if (d[1]) { if (hasGroup(p, d[1]).length) bad = true; } else if ((p.f.gourmand || 0) > 0.34) bad = true; });
      if (bad || !Object.keys(p.f).length) return;
      var s = 0, why = [];
      if (st.family && st.family.length) {
        var fs = 0; st.family.forEach(function (f) { if (p.f[f]) { fs += p.f[f]; if (p.f[f] >= .12) why.push(FAML[f]); } });
        s += Math.min(1, fs / 0.75) * 45; if (fs < 0.1) s -= 25;
      }
      if (st.mood) { var m = MOOD[st.mood], pos = 0, neg = 0, k; for (k in m.pos) pos += (p.f[k] || 0) * m.pos[k]; for (k in m.neg) neg += (p.f[k] || 0) * m.neg[k]; s += Math.max(-15, Math.min(25, (pos - neg * .8) * 45)); }
      if (st.gender && st.gender !== 'all' && p.g === st.gender) s += 4;
      if (p.s === 1 || p.s === 2) s += 2;
      if (p.pop) s += 3;
      out.push({ p: p, s: s, why: why });
    });
    var max = 5 + (st.family && st.family.length ? 45 : 0) + (st.mood ? 25 : 0) + (st.gender && st.gender !== 'all' ? 4 : 0);
    out.sort(function (a, b) { return b.s - a.s; });
    out.forEach(function (x) { x.pct = Math.max(30, Math.min(99, Math.round(x.s / max * 100))); });
    return diversify(out);
  }
  function diversify(list) {
    var res = [], perV = {}, perI = {}, rest = [];
    list.forEach(function (x) { var v = x.p.v, i = x.p.i || ('_' + x.p.h);
      if ((perV[v] || 0) >= 2 || (perI[i] || 0) >= 1) { rest.push(x); return; }
      perV[v] = (perV[v] || 0) + 1; perI[i] = (perI[i] || 0) + 1; res.push(x); });
    return res.concat(rest);
  }
  function similarTo(P, ref, opts) {
    opts = opts || {}; var out = [];
    P.forEach(function (p) {
      if (p.x || !p.av || p.h === ref.h || (opts.exclude && opts.exclude[p.h])) return;
      if (opts.gender && opts.gender !== 'all' && p.g !== opts.gender && p.g !== 'Mixte') return;
      if (ref.g && ref.g !== 'Mixte' && p.g !== 'Mixte' && p.g !== ref.g && !opts.gender) return;
      out.push({ p: p, s: similarity(ref, p) });
    });
    out.sort(function (a, b) { return b.s - a.s; });
    return diversify(out);
  }
  function profileOf(items) {
    var f = {}, nv = {};
    items.forEach(function (p) { var k; for (k in p.f) f[k] = (f[k] || 0) + p.f[k] / items.length; var v = noteVec(p); for (k in v) nv[k] = (nv[k] || 0) + v[k] / items.length; });
    return { f: f, _nv: nv, h: '__ref', g: null };
  }

  /* ——— carte produit ——— */
  function money(v) { return v == null ? '' : EN ? '€' + v.toFixed(2) : v.toFixed(2).replace('.', ',') + ' €'; }
  function inspLine(p) {
    if (!p.i || p.l === 'c') return '<div class="epf-insp"><span class="epf-tag epf-tag--muted">' + TX.creation + '</span><span>' + TX.creationLine + '</span></div>';
    if (p.a) return '<div class="epf-insp"><span class="epf-tag epf-tag--muted">' + TX.adn + '</span><span>' + TX.adnLine + '<strong>' + esc(p.i) + '</strong></span></div>';
    if (p.l === 'r') return '<div class="epf-insp"><span class="epf-tag epf-tag--muted">' + TX.res + '</span><span>' + TX.resLine + '<strong>' + esc(p.i) + '</strong></span></div>';
    return '<div class="epf-insp"><span class="epf-tag">' + TX.eq + '</span><span>' + TX.eqLine + '<strong>' + esc(p.i) + '</strong></span></div>';
  }
  var BAG = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 11.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
  function card(p, o) {
    o = o || {};
    var pyr = '';
    if (p.p) pyr = '<dl class="epf-pyr">' + [[TX.top, 0], [TX.heart, 1], [TX.base, 2]].filter(function (x) { return p.p[x[1]] && p.p[x[1]].length; }).map(function (x) { return '<dt>' + x[0] + '</dt><dd>' + esc(p.p[x[1]].map(tn).join(', ')) + '</dd>'; }).join('') + '</dl>';
    else if (p.nl && p.nl.length) pyr = '<dl class="epf-pyr"><dt>' + TX.allNotes + '</dt><dd>' + esc(p.nl.map(tn).join(', ')) + '</dd></dl>';
    var why = o.why && o.why.length ? '<div class="epf-why">' + esc(o.why.join(' · ')) + '</div>' : '';
    var pills = o.top && o.topLabel ? '<span class="epf-pill epf-pill--top">' + esc(o.topLabel) + '</span>' : '';
    if (o.pct && o.pct >= 90) pills += '<span class="epf-pill epf-pill--match">' + (EN ? o.pct + TX.match : o.pct + TX.match) + '</span>';
    if (p.cp && p.price) pills += '<span class="epf-pill epf-pill--sale">-' + Math.round((1 - p.price / p.cp) * 100) + '%</span>';
    var img = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.n) + '" loading="lazy" width="360" height="360">' : '<span class="epf-card__ph" aria-hidden="true">' + esc((p.n || '?').charAt(0)) + '</span>';
    var price = '<span class="epf-card__price">' + money(p.price) + (p.cp ? ' <s>' + money(p.cp) + '</s>' : '') + '</span>';
    return '<article class="epf-card' + (o.top ? ' is-top' : '') + '">' +
      '<a class="epf-card__media" href="' + esc(p.url) + '" tabindex="-1">' + img + (pills ? '<span class="epf-pills">' + pills + '</span>' : '') + '</a>' +
      '<div class="epf-card__body">' +
        '<div class="epf-card__vendor">' + esc(p.v) + ' · ' + esc(TX.g[p.g] || p.g) + '</div>' +
        '<a class="epf-card__name" href="' + esc(p.url) + '">' + esc(p.n) + '</a>' +
        inspLine(p) +
        (pyr ? '<details class="epf-notes"><summary>' + TX.notes + '</summary>' + pyr + '</details>' : '') +
        '<div class="epf-card__foot">' + price +
        '<button type="button" class="epf-add" data-epf-add="' + p.id + '" aria-label="' + esc(TX.addAria.replace('{n}', p.n)) + '">' + BAG + '<span>' + TX.add + '</span></button></div>' +
      '</div></article>';
  }
  function skeleton(n) { var h = ''; for (var i = 0; i < n; i++) h += '<div class="epf-card epf-card--skel" aria-hidden="true"><div class="epf-card__media"></div><div class="epf-card__body"><i></i><i></i><i></i></div></div>'; return h; }

  /* ——— ajout au panier : ouvre le panier latéral du thème ——— */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-epf-add]') : null; if (!b || b.disabled) return;
    b.disabled = true; var label = b.innerHTML, sp = b.querySelector('span') || b; sp.textContent = TX.adding;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-epf-add'), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Erreur'); return j; }); })
      .then(function () {
        sp.textContent = TX.added; b.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        if (!document.querySelector('cart-drawer')) window.location.href = root + 'cart';
        setTimeout(function () { b.innerHTML = label; b.disabled = false; b.classList.remove('is-done'); }, 2500);
      })
      .catch(function (err) { sp.textContent = err.message && err.message.length < 40 ? err.message : TX.unavailable; setTimeout(function () { b.innerHTML = label; b.disabled = false; }, 3000); });
  });

  window.EPFinder = { FAMS: FAMS, FAML: FAML, DISLIKES: DISLIKES, esc: esc, norm: norm, load: load, scoreAll: scoreAll, similarTo: similarTo, profileOf: profileOf, card: card, skeleton: skeleton, money: money, lang: LANG, en: EN, tn: tn };
})();
